import React from "react";

import clsx from "clsx";

import { Button, SelectorOption } from "@/components/inputs";
import { ProductModel } from "@/models/product/type";

import styles from "./ProductDetailSelects.module.scss";
import { QuantitySelectorPanel } from "./QuantitySelectorPanel";
import { CurrentPoint } from "../../CurrentPoint";
import { SubscriptionTogglePanel } from "../../SubscriptionTogglePanel";

interface ProductDetailSelectsProps {
  product: ProductModel;
  isMobile: boolean;
  isLoggedIn: boolean;
  subscriptionEnabled: boolean;
  hasDifferentSalesTypeInCart: boolean;
  isDisabledSubmitDirect: boolean;
  setSubscriptionEnabled: (value: boolean) => void;
  firstSubscriptionGapPrice: number;
  afterSecondSubscriptionGapPrice: number;
  quantity: number;
  quantityOptions: SelectorOption<number>[];
  setQuantity: (value: number) => void;
  normalSubtotal: number;
  firstSubscriptionSubtotal: number;
  afterSecondSubscriptionSubtotal: number;
  redirectToSubscription: () => void;
  handleClickDirect: () => void;
  handleClickAddToCart: () => void;
}

export function ProductDetailSelectsNormal({
  product,
  isMobile,
  isLoggedIn,
  subscriptionEnabled,
  hasDifferentSalesTypeInCart,
  setSubscriptionEnabled,
  isDisabledSubmitDirect,
  firstSubscriptionGapPrice,
  afterSecondSubscriptionGapPrice,
  quantity,
  quantityOptions,
  setQuantity,
  normalSubtotal,
  firstSubscriptionSubtotal,
  afterSecondSubscriptionSubtotal,
  redirectToSubscription,
  handleClickDirect,
  handleClickAddToCart,
}: ProductDetailSelectsProps): React.ReactNode {
  return (
    <div>
      <SubscriptionTogglePanel
        enabled={subscriptionEnabled}
        onChange={setSubscriptionEnabled}
        firstGapPrice={firstSubscriptionGapPrice}
        afterSecondGapPrice={afterSecondSubscriptionGapPrice}
      />
      <CurrentPoint />
      <QuantitySelectorPanel
        isMobile={isMobile}
        quantity={quantity}
        options={quantityOptions}
        onChange={setQuantity}
        unit={product.meal}
        subscriptionEnabled={subscriptionEnabled}
        firstSubscriptionPrice={firstSubscriptionSubtotal}
        afterSecondSubscriptionPrice={afterSecondSubscriptionSubtotal}
        normalPrice={normalSubtotal}
      />

      {/* ログイン＋継続コースにするの場合のみ、マイページで追加・変更ボタンを表示 */}
      {isLoggedIn && subscriptionEnabled ? (
        <Button
          className={clsx(styles.mypageEditButton, "mg__top__s")}
          onClick={redirectToSubscription}
          variants={"primary"}
          fullWidth
          rounded
        >
          マイページで追加・変更
          <i className={clsx("fas fa-angle-right", styles.angleRight)} />
        </Button>
      ) : (
        <>
          <Button
            variants="primary"
            fullWidth
            rounded
            onClick={handleClickAddToCart}
            disabled={hasDifferentSalesTypeInCart}
            className="mg__top__s"
          >
            カートに追加
          </Button>
          <Button
            variants="secondary"
            rounded
            fullWidth
            disabled={isDisabledSubmitDirect || hasDifferentSalesTypeInCart}
            onClick={handleClickDirect}
            className="mg__top__s"
          >
            いますぐ購入
          </Button>
        </>
      )}

      {/* 下記のパターンなら表示する：
          - アウトレットがカートにある＋ログインしていない
          - アウトレットがカートにある＋ログインしている＋継続コースが有効でない
        */}
      {hasDifferentSalesTypeInCart && !(isLoggedIn && subscriptionEnabled) && (
        <div className="text__s text__bold text__red mg__bottom__s mg__top__s text__center text__left__pc">
          アウトレット商品と通常商品を同時に購入することはできません。カートの中身をご確認ください。
        </div>
      )}
    </div>
  );
}
